import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useSnackbar} from "@commons/snackbar";
import {useAuthContext} from "@hooks/useAuthContext";
import {patchBranchByIdService} from "@/services/branch";

export const useSelectBranch = () => {
    const queryClient = useQueryClient();
    const {enqueueSnackbar} = useSnackbar();
    const {updateUserState} = useAuthContext();
    const keyMutation = ['selectCompany']
    const onMutate = async (data:any) => {
        await queryClient.cancelQueries({queryKey: keyMutation})
        const previousValue = queryClient.getQueryData(keyMutation)
        queryClient.setQueryData(keyMutation, data)
        return {previousValue}
    }
    const mutate = useMutation({
        mutationKey: keyMutation,
        mutationFn: patchBranchByIdService,
        onMutate,
        onSuccess: async (data) => {
            await queryClient.invalidateQueries();
            enqueueSnackbar('Select success Branch!');
            updateUserState(data)
        },
        onError: (error: any) => {
            enqueueSnackbar(error, {
                variant: 'error',
            });
        },
    });
    const removeBranch = async (data:any) => {
        await queryClient.cancelQueries({queryKey: keyMutation})
        queryClient.setQueryData(keyMutation, data)
        return {}
    }
    return {...mutate, removeBranch}
}
